import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FadeIn from 'react-fade-in';
import 'bootstrap/dist/css/bootstrap.min.css';

import styled from "styled-components";


import HomeHeader from "../header/HomeHeader";
import FooterMainView from "../footer/FooterMainView";
import PageTitle from "../common/PageTitle";
import AboutCenterView from "./AboutCenterView";
import New_helmet from "../New_helmet";

class AboutPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    async componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

    }
    render() {

        const FOOTERView =  styled.div` 
    background-color: WHITE;
    height: 146px;
    position: relative;  `;


        return (
            <div id={"AboutPage"} className="overflow-hidden"  style={{backgroundColor: '#000000'}} >
                <New_helmet />

                <HomeHeader/>

                <FadeIn> 

                    <PageTitle title="ABOUT US" />

                    <AboutCenterView/>

                    {/*<AboutDescView/>*/}

                    <FooterMainView />
                </FadeIn>
            </div>
        );

    }
}


AboutPage.propTypes = {
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {   })(
    withRouter(AboutPage)
);



// WEBPACK FOOTER //
// ./src/components/homepage_new/about/AboutPage.js